(function () {
  if (customElements.get('ce-pagination-page') !== undefined) {
    return;
  }

  class PaginationPage extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        collection: 'ce-collection',
        parts: '[data-pagination-page-part]',
        button: '[data-pagination-page-button]',
      };

      this.elements = null;

      this.handleClickButton = this.handleClickButton.bind(this);
    }

    parsedCallback() {
      this.elements = {
        collection: document.querySelector(this.selectors.collection),
        parts: this.querySelectorAll(this.selectors.parts),
        buttons: this.querySelectorAll(this.selectors.button),
      };

      for (let button of this.elements.buttons) {
        button.addEventListener('click', this.handleClickButton);
      }
    }

    disconnectedCallback() {
      for (let button of this.elements.buttons) {
        button.removeEventListener('click', this.handleClickButton);
      }
    }

    handleClickButton(event) {
      const button = event.target.closest(this.selectors.button);

      if (button.hasAttribute('aria-disabled')) {
        return;
      }

      for (let part of this.elements.parts) {
        part.setAttribute('aria-disabled', 'true');
      }

      const url = button.dataset.url;
      this.elements.collection.paginatePage(url);
    }
  }

  customElements.define('ce-pagination-page', PaginationPage);
})();
